// Screen `create-record` — design/screens/CreateRecord.dc.html — owner: S2. The create modal over
// the object's list (its first saved view: the Pipeline board for deals); the same modal opens from
// anywhere via openCreateRecord().
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { EmptyState, NoAccess, Skeleton } from '@dataroom/ui';
import { CreateRecordModal } from '../../../../features/records/CreateRecordModal';
import { ObjectListPage } from '../../../../features/views/ObjectListPage';
import { useObjectCaps } from '../../../../lib/access';
import { t } from '../../../../lib/i18n';
import { Page } from '../../../../shell/Page';
import { useObject } from '../../../../shell/useObject';

export const Route = createFileRoute('/_app/o/$object/new')({
  component: CreateRecordPage,
});

function CreateRecordPage() {
  const { object: key } = Route.useParams();
  const { object, appLabel, loading } = useObject(key);
  const navigate = useNavigate();
  const caps = useObjectCaps(key);
  if (!object) {
    return (
      <Page crumbs={[{ label: key }, { label: t('rcm.new') }]} testId="screen-create-record">
        {loading ? null : (
          <EmptyState icon="database" title={t('rcm.unknown')}>
            {t('rcm.unknownBody')}
          </EmptyState>
        )}
      </Page>
    );
  }
  if (!caps.loaded || !caps.create)
    return (
      <Page crumbs={[{ label: object.labelPlural }, { label: t('rcm.new') }]} testId="screen-create-record">
        {!caps.loaded ? (
          <Skeleton height={180} />
        ) : (
          <NoAccess title={t('rcm.denied', { objects: object.labelPlural })} />
        )}
      </Page>
    );
  return (
    <>
      <ObjectListPage
        key={`list:${object.key}`}
        object={object}
        appLabel={appLabel}
        viewKey={undefined}
        trailCrumb={t('rcm.new')}
      />
      <CreateRecordModal
        key={`create:${object.key}`}
        object={object}
        presentation="page"
        onClose={() => void navigate({ to: '/o/$object', params: { object: key } })}
        onCreated={(rec, another) => {
          if (!another)
            void navigate({ to: '/o/$object/r/$recordId', params: { object: key, recordId: rec.id } });
        }}
      />
    </>
  );
}
